import React from "react";
import Style from "./main.module.css";
import flower from "../../../Assets/Homeimages/portflower.png";
import customer from "../../../Assets/About/Portfolio.svg";
import frame1 from "../../../Assets/Homeimages/companyslight.svg";
import frame2 from "../../../Assets/Homeimages/indepth.svg";
import frame3 from "../../../Assets/Homeimages/frame3.png";
import frame4 from "../../../Assets/Homeimages/frame4.png";
import { FaArrowRight } from "react-icons/fa";
import icon1 from "../../../Assets/Homeimages/homepage-contact.svg";
import icon2 from "../../../Assets/Homeimages/homepage-contact1.svg";
import icon3 from "../../../Assets/Homeimages/service.png";
import { useNavigate } from "react-router-dom";
import defaultIMG from "../../../Assets/defaultimg.png";

const CustomerService = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/about");
  };

  const handlecontactus = () => {
    navigate("/contactus");
  };

  return (
    <div className={Style.customer_service_container}>
      <div className={Style.header_screen}>
        <div className={Style.headerbox}>
          <div className={Style.headerbox_img_c}>
            <img
              src={icon2}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = defaultIMG;
              }}
              alt="image"
              className={Style.svgcolored}
            />
          </div>

          <h4 className={Style.headerbox_text}>
            Contact Us for more information
          </h4>
          <div
            className={Style.headerbox_iconcontainer}
            onClick={handlecontactus}
            style={{ cursor: "pointer" }}
          >
            <FaArrowRight size={18} />
          </div>
        </div>
        <div className={Style.headerbox}>
          <div className={Style.headerbox_img_c}>
            <img
              src={icon1}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = defaultIMG;
              }}
              alt="image"
              className={Style.svgcolored}
            />
          </div>
          <h4 className={Style.headerbox_text}>Get to know more about us</h4>

          <div
            className={Style.headerbox_iconcontainer}
            onClick={handleNavigate}
            style={{ cursor: "pointer" }}
          >
            <FaArrowRight size={18} />
          </div>
        </div>
      </div>

      <div className={Style.customer_mainscreen}>
        <div
          className={Style.customer_mains_info}
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <div className={Style.headerIcon}>
            <div className={Style.portimg_container}>
              <img
                src={flower}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = defaultIMG;
                }}
                alt="image"
              />
            </div>
            <p className={Style.portptext}>portfolio</p>
          </div>
          <div className={Style.portcontainer}>
            <h2 className={Style.portheader}>
              Empowering Financial
              <br /> Insight: Welcome to KOHERE
            </h2>
            <p className={Style.porttext}>
              Welcome to KOHERE, your dedicated partner in achieving a
              comprehensive understanding of business financial performance. We
              believe that seamless access to key data and vital documents is
              essential. At KOHERE, we're committed to providing you with the
              tools for informed decision-making. Join us on this journey
              towards financial insights and excellence.
            </p>
          </div>
          <div className={Style.boxcontainer}>
            <div className={Style.card}>
              <div className={Style.box1}>
                <div className={Style.boxImagecontainer}>
                  <img
                    src={frame1}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = defaultIMG;
                    }}
                    alt="image"
                    className={Style.svgcolored}
                  />
                </div>
                <p className={Style["boxtext"]}>Company Insights</p>
              </div>
              <div className={Style.box2}>
                <div className={Style.boxImagecontainer}>
                  <img
                    src={frame3}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = defaultIMG;
                    }}
                    alt="image"
                    className={Style.boximg}
                  />
                </div>
                <p className={Style["boxtext"]}>Company Insights</p>
              </div>
            </div>
            <div className={Style.card}>
              <div className={Style.box1}>
                <div className={Style.boxImagecontainer}>
                  <img
                    src={frame2}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = defaultIMG;
                    }}
                    alt="image"
                    className={Style.svgcolored}
                  />
                </div>
                <p className={Style["boxtext"]}>In-Depth Access</p>
              </div>
              <div className={Style.box2}>
                <div className={Style.boxImagecontainer}>
                  <img
                    src={frame4}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = defaultIMG;
                    }}
                    alt="image"
                    className={Style.boximg}
                  />
                </div>
                <p className={Style["boxtext"]}>In-Depth Access</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={Style.customer_main_image}
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <img
            src={customer}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = defaultIMG;
            }}
            className={Style.customer_main_img}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerService;
